<template>
  <b-card id="filters" class="mb-4" header-bg-variant="custom" no-body>
    <template #header>
      <h4 v-html="$t(tKey + 'header')" class="mb-1 text-white" />
    </template>
    <b-card-body>
      <b-row>
        <b-col sm="12" class="mt-3">
          <b-input-group :prepend="this.$t('filter.indicator')" class="mb-2">
            <b-form-select
              :options="selectIndicator"
              v-model="indicator"
              @input="updateData(indicator, 'indicator')"
            />
          </b-input-group>
        </b-col>
        <b-col sm="12" md="6" class="mt-3">
          <b-card bg-variant="light">
            <b-form-group
              :label="$t('filter.base_data')"
              label-size="lg"
              label-class="font-weight-bold pt-0"
              class="mb-0"
            >
              <b-col sm="12" class="mt-3" v-if="markets">
                <FilterMarkets @transmit="updateData" :multiple="false" :default="'c1'" />
              </b-col>
              <b-col sm="12" class="mt-3" v-if="region">
                <FilterRegion @transmit="updateData" />
              </b-col>
              <b-col sm="12" class="mt-3" v-if="year">
                <FilterYear @transmit="updateData" />
              </b-col>
            </b-form-group>
          </b-card>
        </b-col>
        <b-col sm="12" md="6" class="mt-3" v-if="this.year">
          <b-card bg-variant="light">
            <b-form-group
              :label="$t('filter.comparison_data')"
              label-size="lg"
              label-class="font-weight-bold pt-0"
              class="mb-0"
            >
              <b-form-checkbox
                id="checkbox-1"
                v-model="comparisonActive"
                name="checkbox-1"
                value="accepted"
                unchecked-value="not_accepted"
                @input="
                  updateData(comparisonActive === 'accepted', 'comparison')
                "
              >{{ $t("filter.activate_comparison") }}</b-form-checkbox>

              <b-col sm="12" class="mt-3">
                <FilterMarkets
                  @transmit="updateData"
                  :default="'c1'"
                  :multiple="false"
                  propKey="marketsCompare"
                  :active="this.comparisonActive !== 'accepted'"
                />
              </b-col>
              <b-col sm="12" class="mt-3">
                <FilterRegion
                  @transmit="updateData"
                  propKey="regionCompare"
                  :active="this.comparisonActive !== 'accepted'"
                />
              </b-col>
              <b-col sm="12" class="mt-3">
                <FilterYear
                  @transmit="updateData"
                  propKey="yearCompare"
                  :active="this.comparisonActive !== 'accepted'"
                />
              </b-col>
            </b-form-group>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6">
          <RefreshButton class="mt-3" @refresh="refresh" />
        </b-col>
        <b-col md="6">
          <b-button @click="printReport" class="bg-custom border-custom mt-3">
            <font-awesome-icon class="mr-2" icon="file-excel" />
            &nbsp;
            {{ $t('factsheet.printExcelReport') }}
          </b-button>
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import FilterYear from "./FilterYear";
import FilterRegion from "./FilterRegion";
import FilterMarkets from "./FilterMarkets";
import RefreshButton from "./RefreshButton";

export default {
  props: {
    markets: { type: Boolean, default: false },
    region: { type: Boolean, default: false },
    year: { type: Boolean, default: false },
  },
  components: {
    FilterYear,
    FilterRegion,
    FilterMarkets,
    RefreshButton,
  },
  data() {
    return {
      status: null,
      indicator: "overnights",
      selectIndicator: [
        {
          text: this.$t("dashboard.kpi.overnights.header"),
          value: "overnights",
        },
        {
          text: this.$t("dashboard.kpi.arrivals.header"),
          value: "arrivals",
        },
        {
          text: this.$t("dashboard.kpi.stay.header"),
          value: "stay",
        },
        {
          text: this.$t("dashboard.kpi.etablissements.header"),
          value: "etabs",
        },
        {
          text: this.$t("dashboard.kpi.rooms.header"),
          value: "rooms",
        },
        {
          text: this.$t("dashboard.kpi.beds.header"),
          value: "beds",
        },
      ],
      tKey: "filter.",
      comparisonActive: "false",
      params: {
        year: null,
        region: null,
        markets: null,
        year: null,
        region: null,
        markets: null,
        comparison: null,
        indicator: null,
      },
    };
  },
  methods: {
    updateData(value, key) {
      this.params[key] = value;
    },
    refresh() {
      this.$emit("refresh", this.params);
    },
    printReport() {
      this.refresh();

      // build url for excel export
      let url = "https://api.tourobs.ch/api/hesta/ExportExcelFactsheet?year=" + this.params.year;
      url += "&destination=" + this.params.region.map((r) => r.value);
      url += "&fsmarket=" + this.params.markets.Value;
      if (this.params.comparison) {
        url += "&yearCompare=" + this.params.yearCompare;
        url += "&competitor=" + this.params.regionCompare.map((r) => r.value);
        url += "&fsmarketCompare=" + this.params.marketsCompare.Value;
      }
      window.open(url, '_blank');
    },
  },
  mounted() {
    this.updateData(this.comparisonActive === "accepted", "comparison");
    this.updateData(this.indicator, "indicator");
    this.refresh();
  },
};
</script>

<style></style>
